<template lang="pug">
    v-btn(@click="openLanguageWindow()" color="blue6" class="white--text pl-2 pr-2 mr-4" style="position:relative;")
        img(v-if="getLanguage === 'en'" src="/images/flag_EN.png" width="30")
        img(v-else-if="getLanguage === 'se' || getLanguage === 'sv'" src="/images/flag_SE.png" width="30")
        div(v-if="show" id="showLanguagePopupElement" style="position:absolute; text-transform:none; left:-183px; top:30px; width:220px; background-color:white; box-shadow:3px 3px 15px rgba(0, 0, 0, 0.35); border:0px solid black !important;")
            div(class="text-center white black--text" style="height:30px; width:100%; font-size:12px; border-bottom:1px solid black !important;")
                div(class="text-left" style="display:inline-block; width:150px; margin-top:6px; border:0px solid black !important;") Language
            div(class="text-center mt-4 mb-6" style="background-color:white; width:100%; height:22px; border:0px solid;")
                div(@click="changeLanguage('en')" class="pt-1" :style="getLanguage === 'en' ? 'background-color:#4077AB; color:#FFFFFF;' : 'color:#4077AB;'" style="display:inline-block; height:22px; width:75px; border:1px solid #4077AB;") English
                div(@click="changeLanguage('se')" class="pt-1" :style="getLanguage === 'se' || getLanguage === 'sv' ? 'background-color:#4077AB; color:#FFFFFF;' : 'color:#4077AB;'" style="display:inline-block; height:22px; width:75px; border:1px solid #4077AB;") Swedish
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'SelectLanguagePopupWindow',
    data() {
        return {
            show: false,
            getLanguage: ''
        };
    },
    mounted() {
        let counter = 0;

        const myInterval = setInterval(() => {
            console.log(counter);

            if(localStorage.getItem('visitorLanguage') !== null || counter >= 400) {
                counter = 0;

                this.getLanguage = this.setLanguage();
                i18n.locale = this.getLandCode();

                clearInterval(myInterval);
            }

            counter++;
        }, 50);
    },
    methods: {
        ...mapMutations([
            'setShowUserLanguage'
        ]),
        getLandCode() {
            if(this.getLanguage === 'en') {
                return 'en';
            } else if(this.getLanguage === 'se') {
                return 'sv';
            }

            return 'sv';
        },
        setLanguage() {
            const user = JSON.parse(localStorage.getItem('user'));

            let language = '';

            if(user.user_id !== 0) {
                language = JSON.parse(user.settings).language;
            } else {
                language = localStorage.getItem('visitorLanguage');
            }

            return language;
        },
        openLanguageWindow() {
            this.setShowUserLanguage(true);
        },
        changeLanguage(language) {
            const tempUserObject = this.user;

            if(tempUserObject.user_id !== 0) {
                const tempSettings = JSON.parse(tempUserObject.settings);

                tempSettings.language = language;

                tempUserObject.settings = JSON.stringify(tempSettings);

                localStorage.setItem('user', JSON.stringify(tempUserObject));

                this.getLanguage = this.setLanguage();

                i18n.locale = this.getLandCode();
            } else {
                this.getLanguage = language;

                localStorage.setItem('visitorLanguage', this.getLandCode());

                i18n.locale = this.getLandCode();
            }
        },
        close(e) {
            const element = document.getElementById('showLanguagePopupElement');

            if(!element.contains(e.target)) {
                console.log('outside');

                this.setShowUserLanguage(false);

                this.show = false;

                window.removeEventListener('click', this.close);
            }
        }
    },
    computed: {
        ...mapGetters([
            'getShowUserLanguage'
        ]),
        user() {
            return JSON.parse(localStorage.getItem('user'));
        }
    },
    watch: {
        getShowUserLanguage() {
            if(this.getShowUserLanguage === true) {
                this.show = true;

                this.setShowUserLanguage(false);

                setTimeout(() => {
                    window.addEventListener('click', this.close);
                }, 300);
            }
        }
    }
}
</script>

<style scoped>

</style>
